import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from "rxjs/operators";
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { BonusTypeId, BonusType, AvailabilityId, ChargeBasisId, ChargeBasisName, BasedOnLifeId, BasedOnLifeName, DeductedWhenId, DeductedWhenName, ParticipantBasedOn, ParticipantBasedOnId, IndexedChargeBasisId } from 'src/app/models/product.constant';
import { ChargePercentageId, ChargePercentageName } from '../../../models/product.constant';

@Injectable({
    providedIn: 'root'
})

export class UtilityService {

    public IndexedStateVariations: any;
    private indexedStateVariations = new BehaviorSubject<any>([]);
    indexedStateVariationsData$ = this.indexedStateVariations.asObservable();

    public VariableStateVariations: any;
    private variableStateVariations = new BehaviorSubject<any>({});
    variableStateVariationsData$ = this.variableStateVariations.asObservable();

    public FixedStateVariations: any;
    private fixedStateVariations = new BehaviorSubject<any>({});
    fixedStateVariationsData$ = this.fixedStateVariations.asObservable();

    public showLoader = new BehaviorSubject<boolean>(true);
    showLoader$ = this.showLoader.asObservable();

    constructor(private http: HttpClient, private router: Router) {
    }

    updateVariationData(newValue: any) {
        this.indexedStateVariations.next(newValue);
    }

    updateVariableVariationData(newValue: any) {
        this.variableStateVariations.next(newValue || {});
    }

    updateFixedVariationData(newValue: any) {
        this.fixedStateVariations.next(newValue || {});
    }

    getBonusBasis(bonusPercentaseBaseId: any) {
        let bonusType = '-';
        bonusPercentaseBaseId = Number(bonusPercentaseBaseId);
        switch (bonusPercentaseBaseId) {
            case BonusTypeId.FixedAccountValue:
                bonusType = BonusType.FixedAccountValue;
                break;
            case BonusTypeId.ContractValue:
                bonusType = BonusType.ContractValue;
                break;
            case BonusTypeId.Others:
                bonusType = BonusType.Others;
                break;
            case BonusTypeId.PurchasePayments:
                bonusType = BonusType.PurchasePayments;
                break;
            case BonusTypeId.BenefitBase:
                bonusType = BonusType.BenefitBase;
                break;
            case BonusTypeId.InterestBonus:
                bonusType = BonusType.InterestBonus;
                break;
            case BonusTypeId.AccumulationValue:
                bonusType = BonusType.AccumulationValue;
                break;
            default:
                break;
        }
        return bonusType;
    }

    getChargeBasis(chargeBasisId: any) {
        chargeBasisId = Number(chargeBasisId);
        let chargeBasis = '-';
        switch (chargeBasisId) {
            case IndexedChargeBasisId.FixedAccountValue:
                chargeBasis = ChargeBasisName.FixedAccountValue;
                break;
            case IndexedChargeBasisId.ContractValue:
                chargeBasis = ChargeBasisName.ContractValue;
                break;
            case ChargeBasisId.Others:
                chargeBasis = ChargeBasisName.Others;
                break;
            case IndexedChargeBasisId.PurchasePayments:
                chargeBasis = ChargeBasisName.PurchasePayments;
                break;
            case IndexedChargeBasisId.BenefitBase:
                chargeBasis = ChargeBasisName.BenefitBase;
                break;
            case IndexedChargeBasisId.InterestBonus:
                chargeBasis = ChargeBasisName.InterestBonus;
                break;
            case IndexedChargeBasisId.AccumulationValue:
                chargeBasis = ChargeBasisName.AccumulationValue;
                break;
            default:
                break;
        }
        return chargeBasis;
    }

    getIndexedChargeBasis(chargeBasisId: any){
        chargeBasisId = Number(chargeBasisId);
        let chargeBasis = '-';
        switch (chargeBasisId) {
            case IndexedChargeBasisId.FixedAccountValue:
                chargeBasis = ChargeBasisName.FixedAccountValue;
                break;
            case IndexedChargeBasisId.ContractValue:
                chargeBasis = ChargeBasisName.ContractValue;
                break;
            case IndexedChargeBasisId.Others:
                chargeBasis = ChargeBasisName.Others;
                break;
            case IndexedChargeBasisId.PurchasePayments:
                chargeBasis = ChargeBasisName.PurchasePayments;
                break;
            case IndexedChargeBasisId.BenefitBase:
                chargeBasis = ChargeBasisName.BenefitBase;
                break;
            case IndexedChargeBasisId.InterestBonus:
                chargeBasis = ChargeBasisName.InterestBonus;
                break;
            case IndexedChargeBasisId.AccumulationValue:
                chargeBasis = ChargeBasisName.AccumulationValue;
                break;
            default:
                break;
        }
        return chargeBasis;
    }
    
    getFixedChargeBasis(chargeBasisId: any){
        chargeBasisId = Number(chargeBasisId);
        let chargeBasis = '-';
        switch (chargeBasisId) {
            case IndexedChargeBasisId.FixedAccountValue:
                chargeBasis = ChargeBasisName.FixedAccountValue;
                break;
            case IndexedChargeBasisId.ContractValue:
                chargeBasis = ChargeBasisName.ContractValue;
                break;
            case ChargeBasisId.Others:
                chargeBasis = ChargeBasisName.Others;
                break;
            case IndexedChargeBasisId.PurchasePayments:
                chargeBasis = ChargeBasisName.PurchasePayments;
                break;
            case IndexedChargeBasisId.BenefitBase:
                chargeBasis = ChargeBasisName.BenefitBase;
                break;
            default:
                break;
        }
        return chargeBasis;
    }
    
    getVAChargeBasis(chargeBasisId: any){
        chargeBasisId = Number(chargeBasisId);
        let chargeBasis = '-';
        switch (chargeBasisId) {
            case 1:
                chargeBasis = ChargeBasisName.VariableAccountValue;
                break;
            case 2:
                chargeBasis = ChargeBasisName.FixedAccountValue;
                break;
            case 3:
                chargeBasis = ChargeBasisName.ContractValue;
                break;
            case 4:
                chargeBasis = ChargeBasisName.Others;
                break;
            case 5:
                chargeBasis = ChargeBasisName.PurchasePayments;
                break;
            case 6:
                chargeBasis = ChargeBasisName.BenefitBase;
                break;
            case 7:
                chargeBasis = ChargeBasisName.AccumulationValue;
                break;
            default:
                break;
        }
        return chargeBasis;
    }

    getBasedOnLife(basedOnLifeId: any) {
        basedOnLifeId = Number(basedOnLifeId);
        let basedOnLife = '-';
        switch (basedOnLifeId) {
            case BasedOnLifeId.Owner:
                basedOnLife = BasedOnLifeName.Owner;
                break;
            case BasedOnLifeId.Annuitant:
                basedOnLife = BasedOnLifeName.Annuitant;
                break;
            case BasedOnLifeId.OwnerAndAnnuitant:
                basedOnLife = BasedOnLifeName.OwnerAndAnnuitant;
                break;
            case BasedOnLifeId.OwnerOrAnnuitant:
                basedOnLife = BasedOnLifeName.OwnerOrAnnuitant;
                break;
            default:
                break;
        }
        return basedOnLife;
    }

    getDeductedWhen(deductedWhenId: any) {
        deductedWhenId = Number(deductedWhenId);
        let deductedWhen = '-';
        switch (deductedWhenId) {
            case DeductedWhenId.Daily:
                deductedWhen = DeductedWhenName.Daily;
                break;
            case DeductedWhenId.BiMonthly:
                deductedWhen = DeductedWhenName.BiMonthly;
                break;
            case DeductedWhenId.Monthly:
                deductedWhen = DeductedWhenName.Monthly;
                break;
            case DeductedWhenId.Qauterly:
                deductedWhen = DeductedWhenName.Qauterly;
                break;
            case DeductedWhenId.SemiAnnually:
                deductedWhen = DeductedWhenName.SemiAnnually;
                break;
            case DeductedWhenId.Annually:
                deductedWhen = DeductedWhenName.Annually;
                break;
            default:
                break;
        }
        return deductedWhen;
    }

    getChargePercentage(chargePercentageId: any) {
        chargePercentageId = Number(chargePercentageId);
        let chargePercentageName = '-';
        switch (chargePercentageId) {
            case ChargePercentageId.Simple:
                chargePercentageName = ChargePercentageName.Simple;
                break;
            case ChargePercentageId.Compound:
                chargePercentageName = ChargePercentageName.Compound;
                break;
            default:
                break;
        }
        return chargePercentageName;
    }

    getAvailability(availabilityId: number) {
        let availability = '';
        switch (availabilityId) {
            case AvailabilityId.Individual:
                availability = 'Available as Individual Only';
                break;
            case AvailabilityId.Combine:
                availability = 'Available only in Combination';
                break;
            case AvailabilityId.Both:
                availability = 'Available both as Individual & Combination';
                break;
            default:
                break;
        }
        return availability;
    }

    getUSStatesJson() {
        return this.http.get<any>(`https://docs.mapbox.com/mapbox-gl-js/assets/us_states.geojson`).pipe(
            map((response) => {
                return response;
            })
        );
    }

    getParticipantBasedOn(id: number) {
        let partipant = '';
        switch (id) {
            case ParticipantBasedOnId.Owner:
                partipant = ParticipantBasedOn.Owner
                break;
            case ParticipantBasedOnId.Annuitant:
                partipant = ParticipantBasedOn.Annuitant
                break;
            case ParticipantBasedOnId.OwnerAndAnnuitant:
                partipant = ParticipantBasedOn.OwnerAndAnnuitant
                break;
            case ParticipantBasedOnId.OwnerOrAnnuitant:
                partipant = ParticipantBasedOn.OwnerOrAnnuitant
                break;
            default:
                break;
        }
        return partipant;
    }

    getConflictBenefit(riderType: string, conflictingBenefitsVersions = []): string {
        // this.conflictingBenefitsVersions.filter((x: any) => x.riderType == riderType).map((x: any) => x.confType);
        const conflictBenefits = conflictingBenefitsVersions.filter((x: any) => x.riderType == riderType);
        if (conflictBenefits.length > 0) {
            return conflictBenefits.map((x: any) => x.confType).toString();
        } else {
            return 'N/A';
        }
    }

    trackByFn(index: number, item: any) {
        return item.id;
    }

    setLoader(value: boolean) {
        this.showLoader.next(value);
    }

    /**
     * Sorts rider/benefit lists with closed items (isTerminated) at the end.
     * Open items are sorted by name ascending, closed items by closedDate descending then name.
     * @param items Array to sort
     * @param nameKeys Optional array of property names to check for the name field (e.g., ['name', 'featureName'])
     * @returns Sorted array (new array, original is not modified)
     */
    sortRiderList<T>(items: T[], nameKeys: string[] = ['name']): T[] {
        if (!items || items.length === 0) return items;
        
        return items.slice().sort((a: any, b: any) => {
            // Helper to get name value (case-insensitive, ASC)
            const getName = (item: any): string => {
                for (const key of nameKeys) {
                    if (item[key]) return item[key];
                }
                return '';
            };

            // Helper to get introductionDate as timestamp (desc, newer first)
            const getIntroductionDate = (item: any): number => {
                if (item.introductionDate) {
                    const date = new Date(item.introductionDate).getTime();
                    return isNaN(date) ? 0 : date;
                }
                return 0;
            };

            // Helper to get closedDate as timestamp (desc, newer first)
            const getClosedDate = (item: any): number => {
                if (item.closedDate) {
                    const date = new Date(item.closedDate).getTime();
                    return isNaN(date) ? 0 : date;
                }
                return 0;
            };

            // Step 1: Place non-terminated (open) first, terminated last
            if (a.isTerminated && !b.isTerminated) return 1;
            if (!a.isTerminated && b.isTerminated) return -1;

            // Step 2: Sort open (not terminated) by introductionDate DESC, then name ASC
            if (!a.isTerminated && !b.isTerminated) {
                const introA = getIntroductionDate(a);
                const introB = getIntroductionDate(b);
                if (introA !== introB) {
                    return introB - introA; // Newer introduction first
                }
                // If same introduction date, sort by name ASC
                const nameA = getName(a).toLowerCase();
                const nameB = getName(b).toLowerCase();
                return nameA.localeCompare(nameB); // Ascending A...Z
            }

            // Step 3: Both closed: sort by closedDate DESC, then name ASC
            if (a.isTerminated && b.isTerminated) {
                const closedA = getClosedDate(a);
                const closedB = getClosedDate(b);
                if (closedA !== closedB) {
                    return closedB - closedA; // Most recently closed first
                }
                const nameA = getName(a).toLowerCase();
                const nameB = getName(b).toLowerCase();
                return nameA.localeCompare(nameB); // Ascending A...Z
            }

            // Fallback to name ASC
            const nameA = getName(a).toLowerCase();
            const nameB = getName(b).toLowerCase();
            return nameA.localeCompare(nameB);
        });
    }

}